import { render, staticRenderFns } from "./LuxinIntro.vue?vue&type=template&id=223be674"
import script from "./LuxinIntro.vue?vue&type=script&lang=js"
export * from "./LuxinIntro.vue?vue&type=script&lang=js"
import style0 from "./LuxinIntro.vue?vue&type=style&index=0&id=223be674&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports